import React, { useState } from "react";
import shehzad from "../assets/team/shehzad.jpeg";
import aliRaza from "../assets/team/ali-raza.jpeg";
import adnan from "../assets/team/adnan.jpeg";
import talha from "../assets/team/talha.jpeg";
import zaheer from "../assets/team/zaheer.jpg";
import arbaz from "../assets/team/arbaz.jpeg";
import ilza from "../assets/team/ilza.jpeg";
import aliHussain from "../assets/team/ali-hussain.jpeg";
import asad from "../assets/team/asad.jpg";

const Team = () => {
 const allMembers = [
    {
      name: "Shehzad Ahmad",
      role: "Chief Executive Officer (CEO) / Founder",
      img: shehzad,
      bio: "Visionary technology leader with 10+ years of experience driving digital transformation, building scalable SaaS platforms, and leading high-growth startups toward global success.",
    },
    {
      name: "Ali Raza",
      role: "Project Manager",
      img: aliRaza,
      bio: "Agile-certified project manager skilled in planning, executing, and delivering complex web and mobile projects on time while maintaining quality and stakeholder alignment.",
    },
    {
      name: "Talha Khan",
      role: "AI / Machine Learning Engineer",
      img: talha,
      bio: "Specializes in developing AI-driven solutions, predictive models, automation systems, and data intelligence pipelines to enhance business efficiency and decision-making.",
    },
    {
      name: "Muhammad Zaheer",
      role: "WordPress & SEO Expert",
      img: zaheer,
      bio: "Experienced WordPress developer and SEO strategist focused on building high-performance websites, optimizing search rankings, and driving organic traffic growth.",
    },
    {
      name: "Arbaz Ali",
      role: "Mobile App Developer (Flutter)",
      img: arbaz,
      bio: "Expert Flutter developer building cross-platform Android and iOS applications with seamless UI, optimized performance, and scalable architecture.",
    },
    {
      name: "Muhammad Adnan",
      role: "Senior Web Application Developer",
      img: adnan,
      bio: "Full-stack web application specialist using modern technologies like React, Node.js, and cloud platforms to deliver secure, scalable, and high-performance systems.",
    },
       {
      name: "Muhammad Asad",
      role: "Full Stack Engineer (MERN, Next.js, .NET Core)",
      img: asad,
      bio: "Specialized in building modern, scalable web applications using the MERN stack and Next.js, with expertise in API integration, performance optimization, and cloud deployment.",
    },    
    {
      name: "Ali Hussain",
      role: "React Native Developer",
      img: aliHussain,
      bio: "Develops scalable and feature-rich cross-platform mobile applications using React Native, ensuring performance, reliability, and smooth user experiences.",
    },
 {
      name: "Ilza",
      role: "Senior UI/UX Designer",
      img: ilza,
      bio: "Creative UI/UX specialist focused on user-centered design, wireframing, prototyping, usability testing, and crafting visually compelling digital experiences.",
    },
    {
      name: "Usman Tariq",
      role: "Business Development Manager",
      img: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d",
      bio: "Drives strategic partnerships, client acquisition, and revenue growth through data-driven market analysis and innovative digital business strategies.",
    },
    {
      name: "Zain Malik",
      role: "WordPress Developer",
      img: "https://images.unsplash.com/photo-1595152772835-219674b2a8a6",
      bio: "Professional WordPress developer creating custom themes, plugins, and SEO-optimized websites tailored to business needs and global audiences.",
    },
    {
      name: "Farhan Ali",
      role: "Shopify Developer",
      img: "https://images.unsplash.com/photo-1531427186611-ecfd6d936c79",
      bio: "Certified Shopify specialist building high-converting e-commerce stores with custom themes, app integrations, optimized checkout flows, and performance enhancements.",
    },
  ];

  const [showAll, setShowAll] = useState(false);

  // Initially show 6 cards (Esha Ahmad is 6th)
  const displayedMembers = showAll ? allMembers : allMembers.slice(0, 8);

  return (
    <section className="min-h-screen bg-gray-50 px-6 py-20">
      {/* Heading */}
      <div className="text-center mb-16 max-w-3xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
          Meet Our Professional Digital Agency Team
        </h2>
        <p className="text-gray-600 text-lg md:text-xl">
          Our expert team specializes in web development, mobile app
          development, AI solutions, UI/UX design, e-commerce management,
          SEO optimization, digital marketing, and brand strategy — delivering
          measurable results for global businesses.
        </p>
      </div>

      {/* Team Grid */}
      <div className="max-w-7xl mx-auto grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
        {displayedMembers.map((member, index) => (
          <div
            key={index}
            className="relative bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-3 group overflow-hidden"
          >
            <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-purple-500 opacity-0 group-hover:opacity-10 transition duration-500"></div>

            <div className="w-28 h-28 mx-auto mb-6 rounded-full overflow-hidden shadow-xl border-4 border-white relative z-10">
              <img
                src={`${member.img}`}
                alt={member.name}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
            </div>

            <h3 className="text-xl font-semibold text-gray-900 text-center relative z-10">
              {member.name}
            </h3>

            <p className="text-blue-600 text-sm font-medium text-center mb-3 relative z-10">
              {member.role}
            </p>

            <p className="text-gray-600 text-sm leading-relaxed text-center relative z-10">
              {member.bio}
            </p>

            <div className="mt-6 mx-auto h-1 w-0 bg-blue-600 group-hover:w-16 transition-all duration-300 rounded-full"></div>
          </div>
        ))}
      </div>

      {/* See More Button */}
      {!showAll && (
        <div className="text-center mt-10">
          <button
            onClick={() => setShowAll(true)}
            className="bg-blue-600 text-white px-6 py-2 rounded-full font-semibold shadow-md hover:bg-blue-700 transition-colors duration-300"
          >
            See More
          </button>
        </div>
      )}
    </section>
  );
};

export default Team;